import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" className="brand-link" onClick={closeMobileMenu}>
          <img src="/hugemajicrealmlogo.png" alt="The Majic Realm" className="brand-logo" />
        </Link>
      </div>

      <button className="mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle menu">
        <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}></span>
      </button>

      <div className={`navbar-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} onClick={closeMobileMenu}>Home</Link>
        <Link to="/marketplace" className={`nav-link ${location.pathname === '/marketplace' ? 'active' : ''}`} onClick={closeMobileMenu}>Marketplace</Link>
        <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`} onClick={closeMobileMenu}>Contact</Link>

        {user ? (
          <>
            <Link to="/settings" className={`nav-link ${location.pathname === '/settings' ? 'active' : ''}`} onClick={closeMobileMenu}>Settings</Link>
            {user.role === 'admin' && (
              <Link to="/admin" className={`nav-link ${location.pathname === '/admin' ? 'active' : ''}`} onClick={closeMobileMenu}>Admin</Link>
            )}
            <div className="user-info">
              <span className="username">{user.username || user.email}</span>
              <button onClick={() => { logout(); closeMobileMenu(); }} className="logout-btn">Logout</button>
            </div>
          </>
        ) : (
          <Link to="/login" className="nav-link login-link" onClick={closeMobileMenu}>Login</Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;